import { formatHash } from '../Commons/formatters';
import { type SignedMessage } from '@lucid-evolution/lucid';
import 'reflect-metadata';
import { asEntity } from '../Commons/Decorators/Decorator.asEntity';
import { Convertible } from '../Commons/Decorators/Decorator.Convertible';
import { type CS, type TN } from '../Commons/types';
import { hexToStr } from '../Commons/utils';
import { BaseEntity } from './Base/Base.Entity';

@asEntity()
export class PriceEntity extends BaseEntity {
    protected static _apiRoute: string = 'prices';
    protected static _className: string = 'Oracle Price';

    // #region fields

    @Convertible({})
    CS!: CS;

    @Convertible({})
    TN_Hex!: TN;

    @Convertible({})
    TN_Str!: TN;

    @Convertible({})
    date!: Date;

    @Convertible({})
    priceADAx1e6!: bigint;

    @Convertible({})
    signature!: SignedMessage;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        CS: true,
        TN_Hex: true,
        TN_Str: true,
        priceADAx1e6: true,
    };

    // #endregion  db

    // #region class methods

    public show(): string {
        return `${formatHash(this.CS)}, ${hexToStr(this.TN_Hex)}: ${this.priceADAx1e6}`;
    }

    // #endregion class methods
}
